/* eslint-disable */
import React, { Component } from 'react';

const liStyle = {display :"grid"};


export default class AccordionRecap extends Component {


  render() {
    return (
      <li style = {liStyle}>
        {this.props.style.opacity ?
       <a
       onClick = {this.props.onClick}
       className="accordion_title_recap active"
       >
       {this.props.title}
       </a>:

       <a
       onClick = {this.props.onClick}
       className="accordion_title_recap "
       >
       {this.props.title}
       </a>

      }

        <div className={this.props.classNamesecond } style={this.props.style} >
          {this.props.children}
        </div>
      </li>
    );
  }
}
AccordionRecap.propTypes = {
  title: React.PropTypes.string,
  classNamefirst: React.PropTypes.string,
  classNamesecond: React.PropTypes.string,
  style: React.PropTypes.string,
  children: React.PropTypes.node,
  onClick: React.PropTypes.func,
};
AccordionRecap.defaultProps = {
  classNamefirst: 'accordion_title_recap active',
  classNamesecond: 'accordion_content_recap',
  style: { display: 'block' },
};
